import { schema } from 'normalizr';

// {"id":"2434e71b-fc8a-4ca6-a32a-597c31c0ab0c","firebaseId":"voxcluhJhWMETPeSQCYaiBMlDuk1","address":null,"email":"adam.hunter+hedgiesignup71@splitelement.com","createdAt":"2018-07-04T19:46:10Z","updatedAt":"2018-07-04T19:46:10Z","isAcceptedCasl":false}

export const users = new schema.Entity('users', {});
